import { IKeyStringDict } from "@/types/GlobalTypes";

const TH: IKeyStringDict = {
	"language_code": "th",

	"txt_language": "ภาษา",

	"txt_info": "ข้อมูล",
	"txt_userid": "ชื่อผู้ใช้",
	"txt_balance": "คงเหลือ",
	"txt_online_users": "ผู้เล่นออนไลน์",
	"txt_user": "ผู้เล่นอ",
	"txt_online": "อนไลน์",
	"txt_multitable": "หลายโต๊ะ",
	"txt_exit": "ออก",

	"txt_tap_fullscreen": "แตะที่ปุ่มนี้เพื่อไปยังแบบเต็มหน้าจอ",
	"txt_lost_connection_server": "การเชื่อมต่อกับเซิร์ฟเวอร์สูญหายโปรดรีเฟรชเบราเซอร์ของคุณ.",
	"txt_no_how_to_play": "No how to play available for this game",
	"txt_no_data_available": "ไม่มีข้อมูล",

	// Game Categories
	"txt_all_games": "เกมทั้งหมด",
	"txt_fast-tables_games": "FAST TABLE",
	"txt_favorites": "รายการโปรด",
	"txt_categories": "CATEGORIES",
	"txt_dice_games": "เกมลูกเต๋า",
	"txt_ball_games": "เกมลููกบอล",
	"txt_casino_games": "เกมคาสิโน",
	"txt_other_games": "เกมอื่นๆ",

	// Translated Game Names
	"txt_game_name_m6": "24Dspin",
	"txt_game_name_m7": "Oglok",
	"txt_game_name_m8": "Dice 6",
	"txt_game_name_m10": "Head Tail",
	"txt_game_name_m11": "Red White",
	"txt_game_name_m13": "Billiards",
	"txt_game_name_m14": "Poker Dice",
	"txt_game_name_m16": "Gong Ball",
	"txt_game_name_m19": "Suwit",
	"txt_game_name_m20": "Monopoly",
	"txt_game_name_m21": "Monopoly World Cup",
	"txt_game_name_m22": "บาคาร่า",
	"txt_game_name_m23": "เสือมังกร",
	"txt_game_name_m24": "NiuNiu",
	"txt_game_name_m25": "FanTan",
	"txt_game_name_m27": "Shio Fights",
	"txt_game_name_m28": "IDN 4 Stand",
	"txt_game_name_m30": "5D",
	"txt_game_name_m32": "SamGong",
	"txt_game_name_m33": "Gong Ball Jitu",
	"txt_game_name_m34": "HILO",
	"txt_game_name_m35": "48D",
	"txt_game_name_m36": "36D",
	"txt_game_name_p6": "24D",
	"txt_game_name_p7": "Roulette",
	"txt_game_name_p9": "12D",
	"txt_game_name_p12": "Sicbo[Dice]",
	"txt_game_name_m40": "Xoc Dia",
	"txt_game_name_m42": "Pinball",

	// Special Game Names
	"txt_game_name_m26": "Race Ball",
	"txt_game_name_m29": "3D Shio",
	"txt_game_name_m31": "Sicbo Ball - Fast",
	"txt_game_name_p7b": "Roulette 2 - Fast Table",
	"txt_game_name_m17": "Toto Macau",
	"txt_game_name_m37": "Bingo Sicbo",
	"txt_game_name_m38": "Bingo Baccarat",
	"txt_game_name_m38b": "Bingo Baccarat 2",
	"txt_game_name_m39": "Duel Dice",
	"txt_game_name_m50": "Toto Singapore",
	"txt_game_name_m51": "Toto Macau 5D",
	
	"txt_game_name_toto": "IDN Lotto",

	// Lobby-related strings
	"txt_bet_closed": "ปิดเดิมพัน",
	"txt_roadmap": "ตารางประวัติ",
	"txt_history": "ประวัติ",
	"txt_statistics": "สถิติ",
	"txt_statistics_first": "STATISTICS 1ST BALL",
	"txt_show_all_roadmap": "แสดงตารางประวัติทั้งหมด",
	"txt_show_all_history": "แสดงประวัติทั้งหมด",
	"txt_play_now": "เล่นตอนนี้",
	"txt_new_game_badge": "ใหม่",
	"txt_history_result": "ประวัติเกม",
	"txt_history_win": "ประวัติชนะ",
	"txt_how_to_play": "วิธีเล่น",
	"txt_full_screen": "แบบเต็มจอ",
	"txt_total_bet": "การเดิมพันทั้งหมด",
	"txt_transaction": "รายการธุรกรรม",
	"txt_news": "ข่าว",
	"txt_settings": "ตั้งค่า",
	"txt_promotions": "โปรโมชั่น",
	"txt_new_game": "เกมส์ใหม่",
	"txt_new_features": "คุณสมบัติใหม่",
	"txt_bonus_history": "ประวัติโบนัส",
	"txt_memo": "จดหมาย",
	"txt_referral": "แนะนำ",
	"txt_periode": "รหัสรอบ",
	"txt_number": "จำนวน",
	"txt_back": "Back",
	"txt_back_to_lobby_message": "Are you sure you want to go back to Lobby?",
	"txt_yes": "Yes",
	"txt_no": "No",
	"txt_transaction_history": "ประวัติธุรกรรม",
	"txt_result_history": "ประวัติเกม",
	"txt_number_pagination": "จำนวน.",
	"txt_date": "วันที่",
	"txt_status": "สะถานะ",
	"txt_debit": "หักบัญชี",
	"txt_credit": "เครดิต",
	"txt_win": "ชนะ",
	"txt_won": "วอน",
	"txt_lose": "แพ้",
	"txt_buy": "ซื้อ",
	"txt_refund": "Refund",
	"txt_bet": "เดิมพัน",
	"txt_guess": "เดา",
	"txt_prize": "รางวัล",
	"txt_discount": "ส่วนลด",
	"txt_x_win": "X-ชนะ",
	"txt_correction": "Correction",
	"txt_total_win": "จำนวนเงินชนะ",
	"txt_total": "จำนวนเดิมพันรวม",
	"txt_type": "ประเภท",
	"txt_amount": "จำนวน",
	"txt_touch_to_close": "แตะที่นี่เพื่อปิด",
	"txt_all_odd": "All Odd",
	"txt_all_even": "All Even",
	"txt_all_low": "All Low",
	"txt_all_high": "All High",
	"txt_clear": "Clear",
	"txt_undo": "Undo",
	"txt_rebet": "Rebet",
	"txt_submit": "Submit",
	"txt_table_name": "ชื่อโต๊ะ",
	"txt_bet_limit": "วงเงินเดิมพัน",
	"txt_min_number": "เดิมพันขั้นต่ำ",
	"txt_max_number": "เดินพันสูงสุด",
	"txt_min_50": "ขั้นต่ำ50",
	"txt_max_50": "สูงสุด50",
	"txt_table_information": "Table Information",
	"txt_toggle_streaming": "Toggle Streaming",
	"txt_wait_next_round": "รอรอบต่อไป",
	"txt_place_bet": "วางเดิมพันของคุณ",
	"txt_bet_close_in": "ปิดรับเดิมพันใน",
	"txt_video_is_off_desktop_message": "Video is off\nGo to settings to turn on",
	"txt_video_is_off_mobile_message": "Video is off\nTap to turn on",
	"txt_loading_video": "Loading video...",
	"txt_odd_even": "คี่-คู่",
	"txt_odd": "คี่",
	"txt_even": "คู่",
	"txt_small_big": "เล็ก-ใหญ่",
	"txt_small": "เล็ก",
	"txt_big": "ใหญ่",
	"txt_detail": "เกร็ด",
	"txt_red": "แดง",
	"txt_blue": "ฟ้า",
	"txt_black": "ดำ",
	"txt_white": "สีขาว",
	"txt_head": "หัว",
	"txt_tail": "หาง",
	"txt_banker": "แบงค์เกอร์",
	"txt_player": "เพลย์เยอร์",
	"txt_result": "ผลลัพธ์",
	"txt_any_double": "Any Double",
	"txt_any_triple": "ถูกแถวใดๆ",
	"txt_triple": "สามเท่า",
	"txt_one": "หนึ่ง",
	"txt_two": "สอง",
	"txt_three": "สาม",
	"txt_four": "สี่",
	"txt_five": "ห้า",
	"txt_six": "หก",
	"txt_seven": "เจ็ด",
	"txt_eight": "แปด",
	"txt_nine": "เก้า",
	"txt_ten": "สิบ",
	"txt_balls_passed_line": "Balls passed line",
	"txt_balls": "ball(s)",
	"txt_on_one_dice": "ในหนึ่งลูกเต๋า",
	"txt_on_two_dice": "ในสองลูกเต๋า",
	"txt_on_three_dice": "ในสามลูกเต๋า",
	"txt_shrimp": "กุ้ง",
	"txt_chicken": "ไก่",
	"txt_jug": "น้ำเต้า",
	"txt_crab": "ปู",
	"txt_fish": "ปูลา",
	"txt_2_pairs": "2 คู่",
	"txt_3_of_a_kind": "ทรีออฟอะไคนด์",
	"txt_inc_straight": "สเตรท / ไม่ติดต่อกัน",
	"txt_flush": "ฟลัช",
	"txt_full_house": "ฟูลเฮ้าส์",
	"txt_straight": "สเตรท",
	"txt_4_of_a_kind": "โฟร์ออฟอะไคนด์",
	"txt_inc_straight_flush": "สเตรทฟลัช / ไม่ติดต่อกัน",
	"txt_straight_flush": "สเตรทฟลัช",
	"txt_5_of_a_kind": "ไฟท์ออฟอะไคนด์",
	"txt_line": "แถว",
	"txt_row": "แถว",
	"txt_1st_line": "แถว1",
	"txt_2nd_line": "แถว2",
	"txt_3rd_line": "แถว3",
	"txt_4th_line": "แถว4",
	"txt_5th_line": "แถว5",
	"txt_6th_line": "แถว6",
	"txt_7th_line": "แถว7",
	"txt_8th_line": "แถว8",
	"txt_9th_line": "แถว9",
	"txt_10th_line": "แถว10",
	"txt_1st_row": "แถว1",
	"txt_2nd_row": "แถว2",
	"txt_3rd_row": "แถว3",
	"txt_4th_row": "แถว4",
	"txt_2_to_1": "2 ถึง 1",
	"txt_1st_2nd_line": "แถวที่1 และ2",
	"txt_2nd_3rd_line": "แถวที่2 และ3",
	"txt_3rd_4th_line": "แถวที่3 และ4",
	"txt_4th_5th_line": "แถวที่4 และ5",
	"txt_5th_6th_line": "แถวที่5 และ6",
	"txt_1st_line_2nd_line": "แถวที่1 และแถวที่2",
	"txt_3rd_line_4th_line": "แถวที่3 และแถวที่4",
	"txt_1_to_18": "1 ถึง 18",
	"txt_19_to_36": "19 ถึง 36",
	"txt_left": "ซ้าย",
	"txt_right": "ขวา",
	"txt_key": "ค่าธรรมเนียม",
	"txt_coin": "เหรียญ",
	"txt_jackpot": "แจ็คพอต",
	"txt_pictures": "ภาพ",
	"txt_square": "สี่เหลี่ยม",
	"txt_circle": "วงกลม",
	"txt_others": "อื่นๆ",
	"txt_either_pair": "ฝั่งชนะออกคู่",
	"txt_player_pair": "ผู้เล่นออกคู่",
	"txt_perfect_pair": "ออกคู่ทั้งสองฝั่ง",
	"txt_banker_pair": "เจ้ามือออกคู่",
	"txt_tie": "เสมอ",
	"txt_tie_on": "Tie On",
	"txt_dice": "Dice",
	"txt_shoe": "สำรับไพ่",
	"txt_round_id": "รอบเกมที่ ",
	"txt_new_shoe_message": "New Shoe in progress\nPlease wait",
	"txt_less_bet": "Less Bet",
	"txt_more_bet": "More Bet",
	"txt_sounds": "เสียง",
	"txt_music": "เพลง",
	"txt_auto_confirm_bet": "ยืนยันเดิมพันอัตโนมัติ",
	"txt_auto_rebet": "เดิมพันอัตโนมัติ",
	"txt_video": "วีดีโอ",
	"txt_enable_rotation": "เปิดใช้งานการหมุนหน้าจอ",
	"txt_batu": "ค้อน",
	"txt_gunting": "กรรไกร",
	"txt_kertas": "กระดาษ",
	"txt_jempol": "นิ้วโป้ง",
	"txt_telunjuk": "นิ้วชี้",
	"txt_kelingking": "นิ้วก้อย",
	"txt_rat": "rat",
	"txt_ox": "ox",
	"txt_tiger": "tiger",
	"txt_rabbit": "rabbit",
	"txt_dragon": "dragon",
	"txt_snake": "snake",
	"txt_horse": "horse",
	"txt_goat": "goat",
	"txt_monkey": "monkey",
	"txt_rooster": "rooster",
	"txt_dog": "dog",
	"txt_pig": "pig",
	"txt_tickets": "TICKETS",
	"txt_remove_unwanted_tickets": "Please remove the unwanted tickets before submitting.",
	"txt_submit_to_confirm_rebet": "Click Submit button to confirm Rebet.",
	"txt_no_tickets": "You have no running tickets.",
	"txt_running_tickets": "RUNNING TICKETS",
	"txt_choose_bet_type": "Choose bet type to start.",
	"txt_place_bet_amount": "Please place your bet amount first.",
	"txt_add_tickets": "Add Tickets",
	"txt_choose_bet_type_message": "Please choose Bet Type to start.",
	"txt_remove_unwanted_ticket_message": "Please remove the unwanted tickets before submitting.\nClick Submit button to confirm rebet.",
	"txt_rebet_ticket_message": "You still have rebet tickets!\nTouch \"Show\" to see, then touch Submit to send your bets.",
	"txt_drawing_result": "Drawing Result",
	"txt_m29_first": "First",
	"txt_m29_middle": "Middle",
	"txt_m29_last": "Last",
	"txt_3_pictures": "3 Pictures",
	"txt_any_pictures": "Any Pictures",
	"txt_either_3_picture": "Either 3 Picture",
	"txt_either_any_picture": "Either Any Picture",

	//Gong Ball Jitu
	"txt_gbj_result_message": "To view the live result for the GONG BALL JITU game,  please refer to the GongBall board (left side) on the live streaming.",

	"txt_popup_streaming_quality": "Please change streaming quality to HD here",

	"txt_action": "หนังบู๊",

	// bet panel m39
	"txt_m39_red": "Red",
	"txt_m39_blue": "Blue",
	"txt_m39_tie": "Tie",
	"txt_m39_odd": "Odd",
	"txt_m39_even": "Even",
	"txt_m39_low": "Low",
	"txt_m39_high": "High",
	"txt_m39_Odd/Even": "Odd/Even", 
	"txt_m39_Odd/Odd": "Odd/Odd", 
	"txt_m39_Even/Odd": "Even/Odd", 
	"txt_m39_Even/Even": "Even/Even",
	"txt_m39_Low/High": "Low/High", 
	"txt_m39_Low/Low": "Low/Low", 
	"txt_m39_High/Low": "High/Low", 
	"txt_m39_High/High": "High/High",

	// htp m17
	"txt_m17_out-number": "Out Number",
	"txt_m17_4D/3D/2D": "4D/3D/2D",
	"txt_m17_free-plug": "Free Plug",
	"txt_m17_2D-free-plug": "2D Free Plug",
	"txt_m17_plug-dragon": "Plug Dragon",
	"txt_m17_plug-it-in": "Plug it in",
	"txt_m17_middle-edge": "Middle Edge",
	"txt_m17_combination": "Combination", 
	"txt_m17_base": "Base",
	"txt_m17_50-50": "50-50",
	"txt_m17_shio": "Shio",
	"txt_m17_cross": "Cross",
	"txt_m17_flaming-flower": "Flaming Flower",

	// how to play
	"txt_htp_intro": "บทนำ",
	"txt_htp_rules": "กฎ",
	"txt_htp_placing-bet": "การวางเดิมพัน",
	"txt_htp_bet-desc": "คำอธิบายและตัวอย่างการเดิมพัน",
    "txt_htp_payout": "การจ่ายเงิน",
	"txt_htp_rank": "อันดับ",
	"txt_complete_information": "DETAILED INFORMATION"
};

export default TH;